import * as arcaneTrickster from '../constants/spells/arcane-trickster.json';
import * as artificer from '../constants/spells/artificer.json';
import * as bard from '../constants/spells/bard.json';
import * as cleric from '../constants/spells/cleric.json';
import * as druid from '../constants/spells/druid.json';
import * as eldritchKnight from '../constants/spells/eldritch-knight.json';
import * as paladin from '../constants/spells/paladin.json';
import * as ranger from '../constants/spells/ranger.json';
import * as sorcerer from '../constants/spells/sorcerer.json';
import * as warlock from '../constants/spells/warlock.json';
import * as wizard from '../constants/spells/wizard.json';
import type { Spell } from '../types';

export const spellLists: Record<string, Spell.Summary[][]> = {
  'arcane-trickster': arcaneTrickster,
  artificer,
  bard,
  cleric,
  druid,
  'eldritch-knight': eldritchKnight,
  paladin,
  ranger,
  sorcerer,
  warlock,
  wizard,
};
